import api from "API/Api"
import React, { useState, useEffect } from "react"
import { Link, useParams } from "react-router-dom"
import { AvForm, AvField } from "availity-reactstrap-validation"
import { Col, Row, Modal, UncontrolledAlert, Spinner } from "reactstrap"

const EditDesignation = () => {
  const { id } = useParams()
  const [desig, setDesig] = useState([])
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    getInfo()
  }, [])

  const getInfo = async () => {
    const response = await api.get("designation/" + id)
    setDesig(response.data.data[0])
  }

  const handleValidSubmit = async (event, values) => {
    setLoading(true)
    try {
    const response = await api.put("update-designation/" + id, values)
    if (response.data.success === true) setSubmitted(true)
    } catch (error) {

      // Handled by global interceptor

    }

    setLoading(false)
  }

  return (
    <>
      <div className="dashBody">
        <div className="font-size-18 mb-0 dashHeader">
          <Row>
            <Col md={6}>
              <h4>Edit Designation</h4>
            </Col>
            <Col md={6} style={{ textAlign: "right" }}>
              <Link to="/designations" className="dashBtn">
                <i className=" fas fa-chevron-left "></i> <b> Back</b>
              </Link>
            </Col>
          </Row>
        </div>
        <div className="dashContent">
          <AvForm
            style={{ position: "relative" }}
            className="form-horizontal"
            onValidSubmit={(e, v) => {
              handleValidSubmit(e, v)
            }}
          >
            <div className="mb-3">
              <AvField
                name="designation"
                label="Designation"
                value={desig.designation}
                className="form-control"
                placeholder="Enter Designation"
                type="text"
                required
              />
            </div>

            <div className="mb-3 row mt-4">
              <div className="col-6">
                {submitted ? (
                  <UncontrolledAlert color="success">
                    <strong>Designation is Updated!</strong>
                  </UncontrolledAlert>
                ) : null}
              </div>
              <div className="col-6 text-end">
                <button
                  className="btn btn-primary w-md waves-effect waves-light"
                  type="submit"
                      disabled={loading}
                >
                  {loading ? (
                    <>
                      <Spinner animation="border" size="sm" />
                      <span style={{ paddingLeft: "10px" }}>Updating...</span>
                    </>
                  ) : (
                    <span>Update Designation </span>
                  )}
                </button>
              </div>
            </div>
          </AvForm>
        </div>
      </div>
    </>
  )
}

export default EditDesignation
